import { fetchFormValues } from './utilities';

jQuery(function($)
{
    var { hide } = orion;
    var { show } = orion;

    let contactIndex = 0;
    let formValues = {};

    var $form = $('.js-account-new__form');

    var $check = $('.js-account-new__check');
    var $checkContactSecond = $('.js-account-new__check-contact-second');
    var $checkContactTemplate = $('.js-account-new__check-contact-template');
    var checkSelectorPrefix = '.js-account-new__check--';

    var $additionalContacts = $('.js-account-new__additional-contacts');
    var $additionalContactButton = $('.js-account-new__additional-contact-button');
    var $additionalContactForm = $('.js-account-new__additional-contact-form');
    var $deleteAdditionalContactButtonText = $('.js-account-new__additional-contacts')
        .data('wizard-delete-contact-text');

    var $salesFocusCheckbox = $('.js-sales-focus-checkbox');

    var $vatIdNumberCheckBox = $('#vatIdentificationNumber-none');
    var $vatIdNumberInput = $('#vatIdentificationNumber');
    var $countryDropDown = $('#home-country');
    var europeanUnionCountryCodesString = $('meta[name=vatRequiredCountryCodes]').attr('content');
    var europeanUnionCountryCodes = [];

    var $tradeCertificate = $('.js-trade-certificate');
    var $tradeCertificateInput = $('.js-trade-certificate input');
    var tradeCertificateCountryCodes = ['DE'];

    $additionalContactForm.addClass('container__other_contact');
    $checkContactTemplate.addClass('container_box__other_contact');

    if (!$('#account-new').length)
    {
        return;
    }

    var [$ustLabel] = $('label[for=\'vatIdentificationNumber\']');
    var [, $eoriLabel] = $('label[for=\'vatIdentificationNumber\']');
    var $ustInfo = $('.vatIdentificationNumber').find('.info');

    if (typeof europeanUnionCountryCodesString !== 'undefined')
    {
        europeanUnionCountryCodes = europeanUnionCountryCodesString.split(',');
    }

    function checkCountryCode()
    {
        if (europeanUnionCountryCodes.length === 0)
        {
            return false;
        }
        return $.inArray($countryDropDown.val(), europeanUnionCountryCodes) < 0;
    }

    function isTradeCertificateRequired()
    {
        return tradeCertificateCountryCodes.indexOf($countryDropDown.val()) !== -1;
    }

    function isGBCountry()
    {
        return $countryDropDown.val() === 'GB';
    }

    function handleChange()
    {
        if ($vatIdNumberCheckBox.is(':checked') || checkCountryCode())
        {
            $vatIdNumberInput.closest('div').removeClass('error');
            $vatIdNumberInput.closest('div').removeClass('missing');
            $vatIdNumberInput.closest('div').removeClass('invalid');
            $vatIdNumberInput.removeAttr('required');
        }
        else
        {
            $vatIdNumberInput.attr('required', 'required');
        }

        if (isGBCountry())
        {
            $($ustLabel).hide();
            $($eoriLabel).show();
            $ustInfo.hide();
        }
        else
        {
            $($ustLabel).show();
            $($eoriLabel).hide();
            $ustInfo.show();
        }

        if (isTradeCertificateRequired())
        {
            show($tradeCertificate);
            show($('.js-account-new__check--tradeCertificate'));
            $tradeCertificateInput.attr('required', 'required');
            $tradeCertificateInput.prop('disabled', false);
        }
        else
        {
            hide($tradeCertificate);
            hide($('.js-account-new__check--tradeCertificate'));
            $tradeCertificateInput.removeAttr('required');
            $tradeCertificateInput.prop('disabled', true);
        }

        initAdditionalContacts();
    }

    function handleSalesFocusCheckboxChange()
    {
        let $checkbox = $(this);
        let salesFocusId = $checkbox.data('salesFocusId');
        let $targetElement = $('[id="' + salesFocusId + '"');
        let $inputs = $targetElement.find('input', 'textarea', 'select');

        if ($checkbox.is(':checked'))
        {
            $targetElement.removeClass('hidden');

            $inputs.each(function()
            {
                let $input = $(this);

                // store location should only be required if the associated checkbox is checked
                if (!$input.is('[name=storeLocationOther]')
                    || ($checkbox.is('#OthersStoreLocationLabel') && $input.is('[name=storeLocationOther]')))
                {
                    $input.attr('required', 'required');
                    $input.attr('tabindex', '0');
                }
            });
        }
        else
        {
            $targetElement.addClass('hidden');

            $inputs.each(function()
            {
                $(this).removeAttr('required');
                $(this).attr('tabindex', '-1');
            });
        }
    }

    /**
	 * Prepares the additional contact form. Changes input names, remove hidden class and add required attribute.
	 * @param $form
	 * @param additionalContactData
	 * @returns {*}
	 */
    function prepareContactFormClone($form, additionalContactData)
    {
        $form.removeClass('hidden');

        let $inputs = $form.find('input');
        let regex = /\[(.*)\]/;

        $inputs.each(function()
        {
            let $input = $(this);

            $input.attr('tabindex', '0');

            if (!$input.is(':radio'))
            {
                let name = $input.attr('name');

                let newName = name.replace('additionalAddress', 'additionalAddress' + contactIndex);

                let [, nameMatch] = name.match(regex);

                if (additionalContactData[nameMatch] !== undefined)
                {
                    $input.val(additionalContactData[nameMatch]);
                }

                $input.attr('name', newName);
                $input.attr('id', newName);

                $('label[for="' + name + '"]', $form).attr('for', newName);

                if (name.indexOf('mobileNumber') === -1
					&& name.indexOf('birthdate') === -1
					&& name.indexOf('position') === -1
                )
                {
                    $input.attr('required', true);
                }
            }
            else
            {
                let name = $input.attr('name');
                let id = $input.attr('id');

                let newName = name.replace('additionalAddress', 'additionalAddress' + contactIndex);
                let newId = id.replace('additionalAddress', 'additionalAddress' + contactIndex);

                let [, nameMatch] = name.match(regex);

                if (additionalContactData[nameMatch] !== 'undefined'
                    && additionalContactData[nameMatch] === $input.val())
                {
                    $input.prop('checked', true);
                }

                $input.attr('name', newName);
                $input.attr('id', newId);
                $input.attr('required', true);

                $('label[for="' + id + '"]', $form).attr('for', newId);
            }
        });

        contactIndex++;

        return $form;
    }

    /**
	 * create hidden input with all additional contacts as JSON encoded string
	 * @param formValues
	 */
    function createAdditionalAddressesHiddenInput(formValues)
    {
        $form.find('[name=additionalContactsJson]').remove();

        delete formValues.additionalAddress;
        formValues['additionalAddresses'] = [];

        for (const inputName in formValues)
        {
            if (inputName.match(/additionalAddress\d+/))
            {
                formValues.additionalAddresses.push(formValues[inputName]);

                delete formValues[inputName];
            }
        }

        let $hiddenAdditionalAddressesInput = $('<input>');

        $hiddenAdditionalAddressesInput.attr('type', 'hidden');
        $hiddenAdditionalAddressesInput.attr('name', 'additionalContactsJson');
        $hiddenAdditionalAddressesInput.val(JSON.stringify(formValues.additionalAddresses));

        $form.append($hiddenAdditionalAddressesInput);
    }

    /**
	 * Copy and prepare additional contact form and add delete button
	 * @param event
	 */
    function handleAdditionalContactButtonClick(event)
    {
        event.preventDefault();
        addAdditionalContact({});
    }

    function addAdditionalContact(additionalContactData)
    {
        let $formClone = $additionalContactForm.clone(true);
        let $newForm = prepareContactFormClone($formClone, additionalContactData);

        let $removeButton = $('<button>');

        $removeButton.html('<i class="fa-regular fa-circle-xmark"></i> ' + $deleteAdditionalContactButtonText);
        $removeButton.addClass('delete_contact');
        $removeButton.on('click', (event) =>
        {
            event.preventDefault();

            $newForm.remove();
        });

        $newForm.append($removeButton);

        $additionalContacts.append($newForm);
    }

    function initAdditionalContacts()
    {
        let $additionalContactJson = $form.find('[name=additionalContactsJson]').val();
        let $additionalContacts = {};

        if ($additionalContactJson !== undefined && $additionalContactJson !== '')
        {
            $additionalContacts = JSON.parse($additionalContactJson);
        }console.log($additionalContacts);

        $.each($additionalContacts, function(contact)
        {
            addAdditionalContact($additionalContacts[contact]);
        });
    }

    function handleFormChange()
    {
        formValues = fetchFormValues($form.get(0), true);

        let dataObjects = {
            additionalAddresses: [],
            tradeCertificate: []
        };

        for (let inputName in formValues)
        {
            let $checkEl = $check.find(checkSelectorPrefix + inputName + ' span');

            if (inputName === 'address')
            {
                for (let subInputName in formValues[inputName])
                {
                    let $checkEl = $check.find(checkSelectorPrefix + subInputName + ' span');

                    if ($checkEl.length)
                    {
                        $checkEl.text(formValues[inputName][subInputName]);
                    }
                }

                continue;
            }

            if (inputName === 'tradeCertificate')
            {
                let files = '';
                let fileListArray = Array.from(formValues[inputName]);

                fileListArray.forEach((file) =>
                {
                    files += file.name + ', ';
                });

                $checkEl.text(files.replace(/, $/, ''));
            }

            if (typeof formValues[inputName] === 'object' && formValues[inputName] !== null)
            {
                /**
				 * The hidden form that is cloned for each new contact has no
				 * index behind it and should not appear in the summary
				 */
                if (inputName.match(/additionalAddress\d+/))
                {
                    dataObjects.additionalAddresses.push(formValues[inputName]);
                }
                else if (inputName.indexOf('additionalAddress') === -1)
                {
                    dataObjects[inputName] = formValues[inputName];
                }

                continue;
            }

            if ($checkEl.length)
            {
                $checkEl.text(formValues[inputName]);
            }
        }

        $checkContactSecond.empty();

        dataObjects.additionalAddresses.forEach((address) =>
        {
            let $checkContactClone = $checkContactTemplate.clone();

            for (let inputName in address)
            {
                let $checkEl = $checkContactClone.find(checkSelectorPrefix + inputName + ' span');

                if ($checkEl.length)
                {
                    $checkEl.text(address[inputName]);
                }
            }

            $checkContactClone.removeClass('hidden');
            $checkContactSecond.prepend($checkContactClone);
        });

        createAdditionalAddressesHiddenInput(formValues);
    }

    $vatIdNumberCheckBox.on('click', function()
    {
        handleChange();
    });

    $countryDropDown.on('change', function()
    {
        handleChange();
    });

    $salesFocusCheckbox.on('change', handleSalesFocusCheckboxChange);

    $form
        .on('change', handleFormChange);
    $additionalContactButton.on('click', handleAdditionalContactButtonClick);

    handleChange();
    handleFormChange();
    $salesFocusCheckbox.trigger('change', handleSalesFocusCheckboxChange);
});
